export interface ProcessStep {
  icon: string;
  title: string;
  desc: string;
}

export interface SharedProcessSectionProps {
  title?: string;
  subtitle?: string;
  steps: ProcessStep[];
}

export default function SharedProcessSection({
  title = 'Our Proven Roofing Process',
  subtitle = 'Simple, transparent, and stress-free — from first call to final walkthrough.',
  steps,
}: SharedProcessSectionProps) {
  return (
    <section id="process" className="py-28 bg-surface">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block w-16 h-1 bg-brand-orange rounded-full mb-6"></div>
          <h2 className="font-heading font-900 text-charcoal text-5xl md:text-6xl lg:text-7xl uppercase tracking-tight leading-none mb-4">
            {title.split(' ').slice(0, -2).join(' ')}<br />
            <span className="text-brand-orange">{title.split(' ').slice(-2).join(' ')}</span>
          </h2>
          <p className="font-body text-charcoal/60 text-lg max-w-xl mx-auto">{subtitle}</p>
        </div>

        {/* Steps */}
        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
            {steps.map((step, i) => (
              <div key={i} className="relative bg-white rounded-2xl p-7">
                {/* Step Number */}
                <div className="font-heading font-900 text-brand-orange/10 text-7xl leading-none absolute top-4 right-5 select-none">
                  {String(i + 1).padStart(2, '0')}
                </div>
                {/* Icon */}
                <div className="w-12 h-12 flex items-center justify-center bg-charcoal rounded-lg mb-5">
                  <i className={`${step.icon} text-brand-orange text-2xl`}></i>
                </div>
                {/* Step indicator */}
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-5 h-5 flex items-center justify-center bg-brand-orange rounded-full flex-shrink-0">
                    <span className="font-heading font-900 text-white text-xs">{i + 1}</span>
                  </div>
                  <span className="font-body text-brand-orange/70 text-xs uppercase tracking-widest">Step {i + 1}</span>
                </div>
                {/* Content */}
                <h3 className="font-heading font-800 text-charcoal text-xl uppercase tracking-wide mb-2">{step.title}</h3>
                <p className="font-body text-charcoal/60 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
